import * as React from 'react'

import {DeleteIcon, EditIcon, TimeIcon} from '@chakra-ui/icons'

import {DataTableAction} from './types'

export const editAction = <T extends {}>(onClick: (item: T) => void): DataTableAction<T> => ({
  icon: <EditIcon />,
  id: 'edit',
  onClick,
  tooltip: 'Edytuj',
})

export const deleteAction = <T extends {}>(onClick: (item: T) => void): DataTableAction<T> => ({
  icon: <DeleteIcon />,
  id: 'delete',
  onClick,
  tooltip: 'Usuń',
})
